import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as loadImage from 'blueimp-load-image';
import { Loader } from '@components/loader';

class ImageViewer extends React.Component<any, any> {
  imageCanvas;
  state = {
    loaded: false
  };

  public componentDidMount() {
    const { src } = this.props;

    loadImage(
      src,
      img => {
        img.className = 'fit_to_parent'; // css class: { max-width: 100%; max-height: 100%; }
        const node = ReactDOM.findDOMNode(this.imageCanvas);
        if (node) {
          node.appendChild(img);
        }
        this.setState({ loaded: true });
      },
      { maxHeight: '300', orientation: true }
    );
  }

  public render() {
    const { loaded } = this.state;
    return (
      <div>
        {!loaded && <Loader />}
        <div ref={ref => (this.imageCanvas = ref)} />
      </div>
    );
  }
}
export default ImageViewer;



// WEBPACK FOOTER //
// ./src/components/imageViewer/ImageViewer.tsx